import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Avatar from '@mui/material/Avatar';
import AccountCircle from '@mui/icons-material/AccountCircle';
import { makeStyles } from '@mui/styles';
import { Downgraded } from '@hookstate/core';
import { useAuthState } from '../../stores/authStore';
import { Tooltip } from '@mui/material';

const useStyles = makeStyles(() => ({
    picStyle: {
        width: 30,
        height: 30,

        fontSize: 12,
    },
    nameStyle: {
        fontSize: 14,
        paddingLeft: '10px',
        textTransform: 'capitalize',
    },
}));

const ProfileInitial = (props) => {
    const classes = useStyles();
    const [userData, setUserData] = React.useState(null);
    const [showOnlyInitial, setShowOnlyInitial] = useState(false);
    const authState = useAuthState();
    useEffect(() => {
        if (
            userData == null ||
            (userData && props.data && props.data.userID != userData.userID)
        ) {
            if (
                props.navigationScreen === 'profile' &&
                authState.isLoggedIn.value
            ) {
                const appDetails = authState
                    .nested('appDetails')
                    .attach(Downgraded)
                    .get();
                setUserData(appDetails.letsgoUser);
            } else {
                setUserData(props.data);
            }
        }
        if (props.showOnlyInitial && props.data) {
            var array = props.data.name.split(',');
            var b = array[0].trim();
            var c = array[1].trim();
            var responseObj = {
                lastName: b,
                firstName: c,
                picUrl: props.data.picUrl,
                name: props.data.name,
                email: props.data.email,
            };

            setUserData(responseObj);
            setShowOnlyInitial(props.showOnlyInitial);
        }
    }, [props]);

    useEffect(() => {
        if (
            props.navigationScreen === 'profile' &&
            authState.isLoggedIn.value &&
            userData
        ) {
            const appDetails = authState
                .nested('appDetails')
                .attach(Downgraded)
                .get();
            const userInfo = appDetails.letsgoUser;
            if (userInfo && userInfo.picUrl != userData.picUrl) {
                setUserData(userInfo);
            }
        }
    }, [authState]);


    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
            }}>
            {userData && userData.profilePicUrl && authState && !showOnlyInitial ? (
                <Avatar
                    alt={`${userData.firstName} ${userData.lastName}`}
                    // srcSet={baseUrl(authState.blobStorage.profileImageContainer.value, userData.picUrl)}
                    srcSet={userData.profilePicUrl}
                    sx={{ width: props.size !== undefined ? props.size : 30, height: props.size ? props.size : 30 }}
                    variant="circular"
                />
            ) : userData &&
                userData.firstName &&
                userData.lastName &&
                showOnlyInitial ? (
                userData && userData.profilePicUrl && authState ? (
                    <Tooltip
                        title={`${userData.firstName} ${userData.lastName}`}
                        aria-label={`${userData.firstName} ${userData.lastName}`}>
                        <Avatar
                            //className={classes.picStyle}
                            alt={userData.name}
                            // srcSet={baseUrl(authState.blobStorage.profileImageContainer.value, userData.picUrl)}
                            srcSet={userData.profilePicUrl}
                            sx={{ width: props.size !== undefined ? props.size : 30, height: props.size ? props.size : 30 }}
                            variant="circular"
                        />
                    </Tooltip>
                )
                    :
                    (<Tooltip
                        title={`${userData.firstName} ${userData.lastName}`}
                        aria-label={`${userData.firstName} ${userData.lastName}`}>
                        <Avatar
                            className={classes.picStyle}
                            sx={{
                                backgroundColor:
                                    props.navigationScreen == 'profile'
                                        ? '#ffffff'
                                        : 'primary.main',
                                color:
                                    props.navigationScreen == 'profile'
                                        ? '#17408B'
                                        : '#ffffff',
                            }}>
                            {userData.firstName.charAt(0).toUpperCase()}
                            {userData.lastName.charAt(0).toUpperCase()}
                        </Avatar>
                    </Tooltip>)
            )
                : userData && userData.firstName && userData.lastName ? (
                    <Tooltip
                        title={`${userData.firstName} ${userData.lastName}`}
                        aria-label={`${userData.firstName} ${userData.lastName}`}>
                        <Avatar
                            className={classes.picStyle}
                            sx={{
                                backgroundColor:
                                    props.navigationScreen == 'profile'
                                        ? '#ffffff'
                                        : '#17408B',
                                color:
                                    props.navigationScreen == 'profile'
                                        ? '#17408B'
                                        : '#ffffff',
                            }}>
                            {userData.firstName.charAt(0).toUpperCase()}
                            {userData.lastName.charAt(0).toUpperCase()}
                        </Avatar>
                    </Tooltip>
                ) : (
                    <AccountCircle fontSize="large" className={classes.picStyle} />
                )}
            {props.navigationScreen == 'profile' ||
                showOnlyInitial ? null : userData ? (
                    <Box sx={{ display: 'flex', flexDirection: 'column' }} >
                        <Typography className={classes.nameStyle} gutterBottom>
                            {userData.firstName.toLowerCase()}{' '}
                            {userData.lastName.toLowerCase()}
                        </Typography>
                        <Typography gutterBottom sx={{ marginBottom: 0, lineHeight: 0.6 }}><a
                            href={`javascript: void(0)`} style={{ textDecoration: 'none', fontSize: '12px', paddingLeft: '10px' }}>
                            {userData.email.toLowerCase()}
                        </a></Typography>
                    </Box>
                ) : null}
        </Box>
    );
};

export default ProfileInitial;
